import React, { useEffect, useRef, useCallback  } from "react";
import { toast, ToastContainer } from "react-toastify";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { annonceNewAdded, annonceGetById, saveImageAnnonce } from "../../../Redux/annonceReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";

function AjouterNew({client}) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  var annee = localStorage.getItem("annee");
  var id = 0
  if (isNaN(location.id) === true) document.title = t("New.add");
  else {
    id = location.id;
    document.title = t("New.update");
  }
  const [titre, setTitre] = React.useState("");
  const [prix, setPrix] = React.useState("");
  const [titreEn, setTitreEn] = React.useState("");
  const [codePct, setCodePct] = React.useState(null);
  const [codeArticle, setCodeArticle] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const [fileNames, setFileNames] = React.useState(null);
  const saveCalled = useRef(false);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  function uploadImage(event) {
    let ImageFile = event.target.files[0];
    if (ImageFile) {
      setFile(ImageFile);
      setFileNames(event.target.files[0].name);
    }
  }

  function submitForm(event) {
    if (
      titre !== "" &&
      codePct !== "" &&
      codeArticle !== "" 
    ) {
      if (isNaN(location.id) === true) {
        if (file !== null) {
          const dataArray = new FormData();
          dataArray.append("file", file);
          dataArray.append("name", file.name);
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(saveImageAnnonce(dataArray))
            .then((val) => {
              var filename = val.payload.filename;
              dispatch(
                annonceNewAdded({
                  filename,
                  titre,
                  titre_en: titreEn,
                  prix,
                  codeArticle,
                  codePct,
                  id,
                  type: 2 , 
                  annee: annee,client
                })
              )
                .then((e) => {
                  if (e.payload == true) {
                    notify(1, t("add_txt"));
                    setTimeout(async () => {
                      navigate.push(client+"/listNew");
                    }, 800);
                  } else {
                    notify(2, t("problem"));
                    saveCalled.current = false;
                  }
                })
                .catch((error) => {
                  notify(2, t("erreur_add"));
                  console.error("Error updating new:", error);
                });
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating new:", error);
            });
        } else {
          notify(2, t("New.required"));
        }
      } else {
        if (file != null) {
          const dataArray = new FormData();
          dataArray.append("file", file);
          dataArray.append("name", file.name);
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(saveImageAnnonce(dataArray))
            .then((val) => {
              var filename = val.payload.filename;
              dispatch(
                annonceNewAdded({
                  filename,
                  titre,
                  titre_en: titreEn,
                  prix,
                  codeArticle,
                  codePct,
                  id,
                  type: 2 , 
                  annee: annee,client
                })
              )
                .then((e) => {
                  if (e.payload == true) {
                    notify(1, t("add_txt"));
                    setTimeout(async () => {
                      navigate.push(client+"/listNew");
                    }, 800);
                  } else {
                    notify(2, t("problem"));
                    saveCalled.current = false;
                  }
                })
                .catch((error) => {
                  notify(2, t("erreur_add"));
                  console.error("Error updating new:", error);
                });
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating new:", error);
            });
        } else {
          if (saveCalled.current) return;
          saveCalled.current = true;
          dispatch(
            annonceNewAdded({
              filename: fileNames,
              titre,
              titre_en: titreEn,
              prix,
              codeArticle,
              codePct,
              id,
              type: 2 , 
              annee: annee,client
            })
          )
            .then((e) => {
              if (e.payload == true) {
                notify(1, t("add_txt"));
                setTimeout(async () => {
                  navigate.push(client+"/listNew");
                }, 800);
              } else {
                notify(2, t("problem"));
                saveCalled.current = false
              }
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              console.error("Error updating new:", error);
            });
        }
      }
    } else {
      notify(2, t("New.required"));
    }
  }


  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);
  
  useEffect(() => {
    verifToken()
    async function getNew() {
      if (isNaN(location.id) === false) {
        var news = await dispatch(annonceGetById(location.id));
        var entities = news.payload;
        if (entities === false) {
          navigate.push(client+'/listNew');
        }
        else {
          setCodeArticle(entities.code_article);
          setFileNames(entities.image);
          setCodePct(entities.code_pct);
          setTitre(entities.titre);
          setTitreEn(entities.titre_en);
          setPrix(entities.prix);
        }
      }
    }
    getNew();
  }, [location.id, dispatch, navigate]);

  function listeNew() {
    navigate.push(client+'/listNew');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeNew}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('New.add')
                        : t('New.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('designation')} * </label>
                          <Form.Control
                            defaultValue={titre}
                            placeholder={t('designation')}
                            type="text"
                            onChange={(value) => {
                              setTitre(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('code_article')} * </label>
                          <Form.Control
                            defaultValue={codeArticle}
                            placeholder={t('code_article')}
                            type="text"
                            onChange={(value) => {
                              setCodeArticle(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t('code_pct')} * </label>
                          <Form.Control
                            value={codePct}
                            placeholder={t('code_pct')}
                            type="text"
                            onChange={(value) => {
                              setCodePct(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                    <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('prix')} * </label>
                          <Form.Control
                            defaultValue={prix}
                            placeholder={t('prix')}
                            type="number"
                            onChange={(value) => {
                              setPrix(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t('image')} *</label>
                          <div className="custom-file">
                            <Form.Control
                              id="test"
                              name="file"
                              type="file"
                              accept="image/png, image/jpeg, image/jpg"
                              onChange={(e) => uploadImage(e)}
                              className="custom-file-input"
                            />
                            <label className="custom-file-label" htmlFor="test">
                              {fileNames ? fileNames : t("Choose_file")}
                            </label>
                          </div>
                        </Form.Group>
                      </Col>

                    </Row>
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container >
    </>
  );
}

export default AjouterNew;
